import { Button } from './button';

export const LIST_PAGE_SIZE = 25;

/**
 * The "Showing 1 - 25 of N" line with Previous / numbered pages / Next that sits under the
 * Documents tabs (All Documents, By Recipient, Credential Requests). Renders nothing when
 * everything fits on one page.
 */
export default function ListPagination({ page, totalPages, totalCount, noun, onPageChange, pageSize = LIST_PAGE_SIZE }) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between" data-testid="list-pagination">
      <p className="text-sm text-muted-foreground">
        Showing {((page - 1) * pageSize) + 1} - {Math.min(page * pageSize, totalCount)} of {totalCount} {noun}
      </p>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page === 1}>
          Previous
        </Button>
        <div className="flex items-center gap-1">
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (page <= 3) {
              pageNum = i + 1;
            } else if (page >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = page - 2 + i;
            }
            return (
              <Button
                key={pageNum}
                variant={page === pageNum ? 'default' : 'outline'}
                size="sm"
                className="w-9"
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </Button>
            );
          })}
        </div>
        <Button variant="outline" size="sm" onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page === totalPages}>
          Next
        </Button>
      </div>
    </div>
  );
}
